/*global jQuery:false */

jQuery(document).ready(function () {
    'use strict';
    let $subProductPerView = $('.pv--viewing-container');
    let $filterSortBtn = $('.openSortingFilter');
    let $filterSortingBox = $('.ps--sorting-container');

    // Manage sorting filter
    const toggleSortingFilter = function () {
        let isSortingActive = 0;

        let manageFilterOuterClick = function () {
            let container =  $('.products-sort')[0];
            $(document).on('click', function( event ) {
                if (isSortingActive && container !== event.target && !container.contains(event.target)) {
                    closeSortFilter();
                    return false;
                }
            });
        }
        const openSortFilter = function () {
            $filterSortBtn.addClass('active');
            $filterSortBtn.attr('aria-expanded', 'true');
            $filterSortingBox.slideToggle('fast');
            isSortingActive = 1;
            manageFilterOuterClick();
        }
        const closeSortFilter = function () {
            $filterSortBtn.removeClass('active');
            $filterSortBtn.attr('aria-expanded', 'false');
            $filterSortingBox.slideToggle('fast');
            isSortingActive = 0;
        }
        $filterSortBtn.on('click', function () {
            if (isSortingActive) {
                closeSortFilter();
            } else {
                openSortFilter();
            }
        });
    }

    toggleSortingFilter();

    // On click, Open view number of items per page
    jQuery('.openView').bind('click', function (e) {

        $(this).toggleClass('active');

        if ($(this).attr('aria-expanded') == 'false') {
            $(this).attr('aria-expanded', 'true');
        } else {
            $(this).attr('aria-expanded', 'false');
        }

        jQuery($subProductPerView).slideToggle('fast');

        e.preventDefault();
    });

    // Expand-collapse Show More - Show Less
    $('.js-extra-filters').hide();
});